import MonthViewTable from "./MonthViewTable";
import MetricMonthsGraph from "./MetricMonthGraph";
import { useSelector } from "react-redux";

const MetricMonthView = () => {
  const forecastGraphAndTableData = useSelector(
    (state: any) => state.forecasters?.forecastGraphAndTableData
  );
  const forecastLastYearData = useSelector(
    (state: any) => state.forecasters?.forecastLastYearData
  );

  const graphData = forecastGraphAndTableData?.query_output?.map(
    (item: any) => ({
      y1: item?.Target,
      y2: item?.Actual,
    })
  );

  const months = forecastGraphAndTableData?.query_output.map((item: any) =>
    new Date(item.Month).toLocaleString("default", {
      month: "short",
      year: "numeric",
    })
  );

  const rows =
    forecastLastYearData?.query_output?.map((item: any) => ({
      Period: item?.period ? item?.period : "N/A",
      Target:
        item.avg_target !== null
          ? parseFloat((parseFloat(item.avg_target))?.toFixed(2))
          : "",
      Actual:
        item.avg_actual !== null
          ? parseFloat((parseFloat(item.avg_actual))?.toFixed(2))
          : "",
      Deviation:
        item.Deviation !== null
          ? parseFloat((parseFloat(item.Deviation))?.toFixed(2))
          : "",
    })) || [];

  return (
    <>
      <MetricMonthsGraph data={graphData} months={months} />
      <MonthViewTable rows={rows} />
    </>
  );
};

export default MetricMonthView;
